import React, {useMemo} from 'react';
import {Table} from "antd";
import {RiseOutlined} from "@ant-design/icons";

const PositionFixedRetainerTab = ({candidate, position}) => {
    const talentOpp = TB.first(candidate?.job_candidate.talent_opps);
    const isCostBased = position.isFixedRetainerCostPerPeriodBased();
    const isRateBased = position.isFixedRetainerRateBased();
    const frequencyType = position.payout_frequency === 'weekly' ? 'weeks' : 'months'

    // Demo toggle for proposal type
    const proposalType = isCostBased ? 'simple' : 'hourly'

    // Calculated values
    const proposedPayoutPerPeriod = useMemo(() => {
        return isRateBased ? (
                (candidate?.job_candidate?.exact_platform_rate * candidate?.job_candidate?.confirmed_avg_hours_per_period)) :
            talentOpp?.platform_cost
    }, [
        talentOpp?.platform_cost,
        candidate?.job_candidate?.exact_platform_rate,
        candidate?.job_candidate?.confirmed_avg_hours_per_period,
        candidate?.job_candidate?.exact_platform_cost,
    ]);
    const totalPeriods = position.actual_total_periods

    const totalProposedPayout = useMemo(() => {
        return candidate?.job_candidate.exact_platform_cost
    }, [candidate?.job_candidate.exact_platform_cost, proposedPayoutPerPeriod, position.actual_total_periods]);

    const projectBudget = useMemo(() => {
        return position.exact_platform_cost
    }, [
        position?.exact_platform_cost,
        position?.actual_total_periods
    ]);

    const isOverBudget = Math.round(totalProposedPayout) > projectBudget;

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        }).format(amount);
    };

    const formatHourlyRate = (rate) => {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(rate);
    };
    console.log('PositionFixedRetainerTab', {projectBudget, totalProposedPayout, budget: 100 * (totalProposedPayout / projectBudget)})

    const percentageOfBudget = (((totalProposedPayout / projectBudget) * 100)).toFixed(1);
    const totalHours = candidate?.job_candidate?.confirmed_avg_hours_per_period * totalPeriods;

    return (
        <div className="proposal-padding">

            {candidate.confirmedStartedAt() && (
                <div className="confirmed-availability-note">
                    <p>
                        The candidate has updated {position.isFixedRetainerRateBased() ? 'their rate': 'their estimated cost'} and confirmed role activities
                    </p>
                    <p>
                        <small>
                            <b>
                                Last Updated: {TB.moment(candidate.job_candidate.talent_proposal_updated_at).fromNow()}
                            </b>
                        </small>
                    </p>
                </div>
            )}
            {/*<h3 className="proposal-tab-header mt-2">*/}
            {/*    Estimated Fee:*/}
            {/*</h3>*/}
            {/*<p className="proposal-input">*/}
            {/*    {!candidate.hasSubmittedProposal() ?*/}
            {/*        'Proposal Cost Pending' :*/}
            {/*        (*/}
            {/*            <span>*/}
            {/*                {candidate.proposedPlatformCost()}*/}
            {/*            </span>*/}
            {/*        )*/}
            {/*    }*/}
            {/*</p>*/}
            {/* Proposal Summary */}
            <div className="max-w-2xl p-6 mb-6 border-2 bg-blue-50 border-blue-100">
                <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
                    <RiseOutlined className="mr-2 text-blue-600" style={{ fontSize: '20px' }} />
                    Candidate Proposal Summary
                </h3>

                <div className="flex flex-wrap justify-between gap-6 mb-4">
                    <div className="text-center">
                        <div className="text-sm text-gray-600 mb-1">Cost per {frequencyType.slice(0, -1)}</div>
                        <div className="text-2xl font-bold text-gray-900">{candidate.hasSubmittedProposal() ? formatCurrency(proposedPayoutPerPeriod) : <i>Pending</i>}</div>
                        {candidate.hasSubmittedProposal() && proposalType === 'hourly' && (
                            <div className="text-xs text-gray-500">
                                {candidate?.job_candidate.confirmed_avg_hours_per_period}hrs × {formatHourlyRate(candidate?.job_candidate?.exact_platform_rate)}
                            </div>
                        )}
                    </div>
                    <div className="text-center">
                        <div className="text-sm text-gray-600 mb-1">Total proposed cost</div>
                        <div className={`text-2xl font-bold text-green-600`}>
                            {candidate.hasSubmittedProposal() ? formatCurrency(totalProposedPayout) : <i>Pending</i>}
                        </div>
                        {candidate.hasSubmittedProposal() && (
                            <div className="text-sm text-gray-500">
                                <b>{percentageOfBudget}%</b> of project budget
                            </div>
                        )}
                    </div>
                </div>

                {candidate.hasSubmittedProposal() && (
                    <div className="pt-4 border-t border-gray-200">
                        <div className="text-sm text-gray-600 space-y-1">
                            <div>Payment schedule: <b>{formatCurrency(proposedPayoutPerPeriod)}</b> × <b>{totalPeriods} {frequencyType}</b> = <b>{formatCurrency(totalProposedPayout)}</b></div>
                            {proposalType === 'hourly' && (
                                <>
                                    <div>Total time commitment: <b>{totalHours}</b> hours over <b>{totalPeriods} {frequencyType}</b></div>
                                    <div>Effective hourly rate: <b>{formatHourlyRate(candidate?.job_candidate?.exact_platform_rate)}</b></div>
                                </>
                            )}
                        </div>
                    </div>
                )}
            </div>

            {/*<hr/>*/}

            {/*<Table*/}
            {/*    rowKey="id"*/}
            {/*    dataSource={TB.orderBy(position.deliverables || [], del => del.target_delivery_at ? TB.moment(del.target_delivery_at).valueOf() : 0, 'asc')}*/}
            {/*    bordered*/}
            {/*    size="middle"*/}
            {/*    pagination={false}>*/}
            {/*    <Table.Column*/}
            {/*        title={(<p className="whitespace-nowrap text-sm">Deliverables</p>)}*/}
            {/*        dataIndex="name"*/}
            {/*        fixed="left"*/}
            {/*        width={200}*/}
            {/*        render={name => (*/}
            {/*            <p className="text-xs">{name}</p>*/}
            {/*        )}*/}
            {/*    />*/}

            {/*    /!*<Table.Column*!/*/}
            {/*    /!*    title={(<p className="whitespace-nowrap text-sm">Target Delivery Date</p>)}*!/*/}
            {/*    /!*    dataIndex="target_delivery_at"*!/*/}
            {/*    /!*    width={50}*!/*/}
            {/*    /!*    render={(target_delivery_at, deliverable) => {*!/*/}
            {/*    /!*        let matchedDel = TB.find(talentOpp.position_deliverables, ['deliverable_id', deliverable.id])*!/*/}
            {/*    /!*        return (*!/*/}
            {/*    /!*            <p className={TB.mapClass("text-xs", {*!/*/}
            {/*    /!*                "line-through opacity-60 text-danger": false//!deliverable.is_active*!/*/}
            {/*    /!*            })}>*!/*/}
            {/*    /!*                {target_delivery_at ? TB.moment(target_delivery_at).format('ll') : (*!/*/}
            {/*    /!*                    <i>No Date Provided...</i>*!/*/}
            {/*    /!*                )}*!/*/}
            {/*    /!*            </p>*!/*/}
            {/*    /!*        )*!/*/}
            {/*    /!*    }}*!/*/}
            {/*    /!*)}*!/*/}

            {/*    /!*{position.fixedFeePricingStrategyIsTotalPayout() && !!TB.find(talentOpp.position_deliverables, del => !!del.total_hours) && (*!/*/}
            {/*    /!*    <Table.Column*!/*/}
            {/*    /!*        title={(<p className="whitespace-nowrap text-sm">Estimated Hours</p>)}*!/*/}
            {/*    /!*        dataIndex="total_hours"*!/*/}
            {/*    /!*        width={40}*!/*/}
            {/*    /!*        render={(total_hours, deliverable) => (*!/*/}
            {/*    /!*            <p className={TB.mapClass("text-xs", {*!/*/}
            {/*    /!*                "line-through opacity-60 text-danger": false//!deliverable.is_active*!/*/}
            {/*    /!*            })}>*!/*/}
            {/*    /!*                {parseInt(total_hours) > 0 ? `${total_hours} hours` : 'Not provided...'}*!/*/}
            {/*    /!*            </p>*!/*/}
            {/*    /!*        )}*!/*/}
            {/*    /!*    />*!/*/}
            {/*    /!*)}*!/*/}

            {/*    {!position.fixedFeePricingStrategyIsTotalPayout() && (*/}
            {/*        <Table.Column*/}
            {/*            title={(<p className="whitespace-nowrap text-sm">Est Cost</p>)}*/}
            {/*            dataIndex="estimated_cost"*/}
            {/*            width={60}*/}
            {/*            render={(_, deliverable) => (*/}
            {/*                <p className={TB.mapClass("text-xs", {*/}
            {/*                    "line-through opacity-60 text-danger": false//!deliverable.is_active*/}
            {/*                })}>*/}
            {/*                    {!TB.isNaN(parseFloat(deliverable.payout_amount)) ? TB.formatCurrency(parseFloat(deliverable.payout_amount)) : '-'}*/}
            {/*                </p>*/}
            {/*            )}*/}
            {/*        />*/}
            {/*    )}*/}

            {/*</Table>*/}
        </div>
    );
};

export default PositionFixedRetainerTab;